import { UserStore } from 'src/shared/stores/user.store';
import { TrialsChatAvailabilityPollingService } from '../services/trials-chat-availability-polling.service';
import { provideTrialsChat } from './trials-chat.providers';

/**
 * Chat-only providers for the trials app (no PolicyStore or other app-specific stores).
 * Chat stores use withUser()/withTenant() which inject UserStore; trials app root may not
 * provide it when the route is lazy-loaded, so we provide UserStore here.
 */
export const TrialsAuthenticatedStoreProviders = [
  UserStore,
  ...provideTrialsChat(),
  TrialsChatAvailabilityPollingService,
];
